// ────────────────────────────────────────────────────────────────────────────
// ENSAYOS
//
// Cada ensayo puede tener:
//   title, type, description, fileName, filePath, fileSize  -> el archivo
//   cultivo, campaña                                        -> para los filtros
//   location: { name, province, lat, lng }                  -> para el MAPA
//
// ⚠️ Las coordenadas (lat/lng) de abajo son DE EJEMPLO. Reemplazá cada
//    { lat, lng } por la ubicación real donde se hizo el ensayo.
//    Para obtener las coordenadas de un lugar: buscalo en Google Maps,
//    hacé click derecho sobre el punto y copiá los dos números (lat, lng).
//
//    Si un ensayo NO tiene ubicación, dejá `location: null` y no aparece
//    en el mapa (pero sí en la lista).
// ────────────────────────────────────────────────────────────────────────────

export const essaysData = [
  {
    title: "Informe Sorgo UNLZ 2025-26",
    type: "PDF",
    description: "Evaluación de rendimiento y calidad en híbridos comerciales y experimentales de sorgo — Facultad de Ciencias Agrarias, Universidad Nacional de Lomas de Zamora",
    fileName: "INFOSorgoUNLZ25-26.pdf",
    filePath: process.env.PUBLIC_URL + "/assets/essays/INFOSorgoUNLZ25-26.pdf",
    fileSize: "5.3 MB",
    cultivo: "Sorgo",
    campaña: "2025-26",
    // 📍 Facultad de Ciencias Agrarias UNLZ (Llavallol)
    location: { name: "Lomas de Zamora", province: "Buenos Aires", lat: -34.774, lng: -58.439 }
  },
  {
    title: "ECR Híbridos de Sorgo Granífero INTA Manfredi 2025-26",
    type: "PDF",
    description: "Ensayo comparativo de rendimiento de 24 híbridos de sorgo granífero en la EEA INTA Manfredi",
    fileName: "INTA_EEAManfredi_Ensayo_hibridos_sorgo_granifero_2025-26.pdf",
    filePath: process.env.PUBLIC_URL + "/assets/essays/INTA_EEAManfredi_Ensayo_hibridos_sorgo_granifero_2025-26.pdf",
    fileSize: "614 KB",
    cultivo: "Sorgo",
    campaña: "2025-26",
    // 📍 EEA INTA Manfredi (mismo pin que el informe ECR 2025)
    location: { name: "Manfredi", province: "Córdoba", lat: -31.842, lng: -63.757 }
  },
  {
    title: "ECR Sorgo Forrajeros y Sileros Reconquista 2024-25",
    type: "PDF",
    description: "Síntesis de ensayos comparativos de rendimiento de sorgo (graníferos, doble propósito, sileros y forrajeros) en el norte de Santa Fe — INTA Reconquista",
    fileName: "Sorgo_2024-25_Reconquista_Forrajeros-Sileros.pdf",
    filePath: process.env.PUBLIC_URL + "/assets/essays/Sorgo_2024-25_Reconquista_Forrajeros-Sileros.pdf",
    fileSize: "382 KB",
    cultivo: "Sorgo",
    campaña: "2024-25",
    // 📍 Reconquista, Santa Fe
    location: { name: "Reconquista", province: "Santa Fe", lat: -29.150, lng: -59.651 }
  },
  {
    title: "Red Sorgo AFA 2024-25",
    type: "Excel",
    description: "Información detallada sobre la red de ensayos de sorgo AFA para la campaña 2024-25",
    fileName: "Red Sorgo AFA 2024-25.xlsx",
    filePath: process.env.PUBLIC_URL + "/assets/essays/Red Sorgo AFA 2024-25.xlsx",
    fileSize: "9.6 KB",
    cultivo: "Sorgo",
    campaña: "2024-25",
    // 📍 EJEMPLO: Cañada de Gómez, Santa Fe — reemplazar por la ubicación real
    location: { name: "Cañada de Gómez", province: "Santa Fe", lat: -32.816, lng: -61.395 }
  },
  {
    title: "Informe Sorgo 2024-25",
    type: "PDF",
    description: "Información completa sobre los ensayos de sorgo para la campaña 2024-25",
    fileName: "INFOSorgo24-25.pdf",
    filePath: process.env.PUBLIC_URL + "/assets/essays/INFOSorgo24-25.pdf",
    fileSize: "3.2 MB",
    cultivo: "Sorgo",
    campaña: "2024-25",
    // 📍 Facultad de Ciencias Agrarias UNLZ (mismo pin que el informe UNLZ 2025-26)
    location: { name: "Lomas de Zamora", province: "Buenos Aires", lat: -34.774, lng: -58.439 }
  },
  {
    title: "Informe ECR 2025 Manfredi",
    type: "PDF",
    description: "Versión preliminar del informe de ensayos comparativos de rendimiento en Manfredi",
    fileName: "VersiÃ³n preliminar informe ECR 2025 Manfredi.pdf",
    filePath: process.env.PUBLIC_URL + "/assets/essays/VersiÃ³n preliminar informe ECR 2025 Manfredi.pdf",
    fileSize: "206 KB",
    cultivo: "ECR",
    campaña: "2024-25",
    // 📍 Manfredi, Córdoba (INTA) — ubicación real conocida por el título
    location: { name: "Manfredi", province: "Córdoba", lat: -31.842, lng: -63.757 }
  },
  {
    title: "Imagen de Ensayo",
    type: "Image",
    description: "Imagen del ensayo de campo",
    fileName: "WhatsApp Image 2025-09-26 at 17.13.14.jpeg",
    filePath: process.env.PUBLIC_URL + "/assets/essays/WhatsApp Image 2025-09-26 at 17.13.14.jpeg",
    fileSize: "178 KB",
    cultivo: "Sorgo",
    campaña: "2024-25",
    // 📍 Cañada de Gómez, Santa Fe (mismo pin que Red Sorgo AFA 2024-25)
    location: { name: "Cañada de Gómez", province: "Santa Fe", lat: -32.816, lng: -61.395 }
  }
];
